// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-profile-menu_wrapper__heQHy {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.user-profile-menu_avatar__Ah5t2 {
  border-radius: 50%;
  background: var(--mui-palette-secondary-400);
  margin-right: 8px;
  scale: 0.7;
}

.user-profile-menu_menuWrapper__zG9Kd {
  box-shadow: none;
  border: 1px solid var(--mui-palette-grey-400);
  border-radius: 6px;
  margin-top: 10px;
}

.user-profile-menu_menuItem__dwQ9q:not(:last-child) {
  margin-bottom: 4px;
}

.user-profile-menu_menuItem__dwQ9q svg {
  scale: 0.9;
  margin-right: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/user-profile-menu/index.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB","sourcesContent":[".wrapper {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.avatar {\n  border-radius: 50%;\n  background: var(--mui-palette-secondary-400);\n  margin-right: 8px;\n  scale: 0.7;\n}\n\n.menuWrapper {\n  box-shadow: none;\n  border: 1px solid var(--mui-palette-grey-400);\n  border-radius: 6px;\n  margin-top: 10px;\n}\n\n.menuItem:not(:last-child) {\n  margin-bottom: 4px;\n}\n\n.menuItem svg {\n  scale: 0.9;\n  margin-right: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `user-profile-menu_wrapper__heQHy`,
	"avatar": `user-profile-menu_avatar__Ah5t2`,
	"menuWrapper": `user-profile-menu_menuWrapper__zG9Kd`,
	"menuItem": `user-profile-menu_menuItem__dwQ9q`
};
export default ___CSS_LOADER_EXPORT___;
